import i18nService from "@/services/i18n"


export class Entry {

    orderIndex: number

    /** ID */
    id: number | null

    /** Код меры государственной поддержки */
    supportMeasureCode: string

    /** Наименование меры государственной поддержки на русском */
    supportMeasureNameRu: string

    /** Наименование меры государственной поддержки на казахском */
    supportMeasureNameKk: string

    /** Наименование меры государственной поддержки */
    get supportMeasureName(): string {
        switch (i18nService.locale) {
            case 'kk':
                return this.supportMeasureNameKk
            case 'en':
                return this.supportMeasureNameRu
            case 'ru':
                return this.supportMeasureNameRu
            default:
                return this.supportMeasureNameRu
        }
    }

    /** План */
    plannedSum: number | null

    /** Выданная сумма */
    issuedSum: number | null

    /** Отклонение */
    get deviation(): number {
        return (this.issuedSum ?? 0) - (this.plannedSum ?? 0)
    }

    /** Примечание на русском */
    noteRu: string | null

    /** Примечание на казахском */
    noteKk: string | null

    /** Примечание */
    get note(): string | null {
        switch (i18nService.locale) {
            case 'kk':
                return this.noteKk
            case 'en':
                return this.noteRu
            case 'ru':
                return this.noteRu
            default:
                return this.noteRu
        }
    }

    constructor(
        orderIndex: number,
        id: number | null,
        supportMeasureCode: string,
        supportMeasureNameRu: string,
        supportMeasureNameKk: string,
        plannedSum: number | null,
        issuedSum: number | null,
        noteRu: string | null,
        noteKk: string | null,
    ) {
        this.orderIndex = orderIndex
        this.id = id
        this.supportMeasureCode = supportMeasureCode
        this.supportMeasureNameRu = supportMeasureNameRu
        this.supportMeasureNameKk = supportMeasureNameKk
        this.plannedSum = plannedSum
        this.issuedSum = issuedSum
        this.noteRu = noteRu
        this.noteKk = noteKk
    }
}

export function parseFormattedNumber(value: string): number {
    if (!value) {
        return 0
    }

    let cleaned = String(value).trim()

    // Strip thousand separators (spaces)
    cleaned = cleaned.replace(/\s/g, "")

    // Keep only the first . or , as the decimal separator, strip any extras
    cleaned = cleaned.replace(/[.,]/g, (m, i) => i === cleaned.search(/[.,]/) ? m : '')

    // Normalize decimal separator to a dot for parsing
    cleaned = cleaned.replace(",", ".")

    return Number(cleaned) || 0
}

export function formatDecimal(value: string | number | null): string | null {
    if (value == null || value === '') {
        return null
    }

    let formatted: string = String(value).trim()

    // Reject input with more than one decimal separator (either . or ,)
    const separatorCount = (formatted.match(/[.,]/g) || []).length
    if (separatorCount > 1) {
        formatted = formatted.replace(/[.,]/g, (m, i) => i === formatted.search(/[.,]/) ? m : '')
        return formatted
    }

    // Split into integer and fractional parts, treating either . or , as the decimal separator
    const decimalMatch = formatted.replace(/\s/g, "").match(/^(-?\d+)(?:[.,](\d+))?$/)
    if (!decimalMatch) {
        return formatted
    }

    const [, integerPart, fractionPart] = decimalMatch

    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ")

    if (!fractionPart) {
        return formattedInteger
    }

    const truncatedFraction = fractionPart.slice(0, 1)

    return `${formattedInteger},${truncatedFraction}`
}

export function formatPositiveDecimal(value: string | number | null): string | null {
    if (value == null || value === '') {
        return null
    }

    let formatted: string = String(value).trim()

    // Reject input with more than one decimal separator (either . or ,)
    const separatorCount = (formatted.match(/[.,]/g) || []).length
    if (separatorCount > 1) {
        formatted = formatted.replace(/[.,]/g, (m, i) => i === formatted.search(/[.,]/) ? m : '')
        return formatted.replace('-', '')
    }

    // Split into integer and fractional parts, treating either . or , as the decimal separator
    const decimalMatch = formatted.replace(/\s/g, "").match(/^(-?\d+)(?:[.,](\d+))?$/)
    if (!decimalMatch) {
        return formatted.replace('-', '')
    }

    const [, integerPart, fractionPart] = decimalMatch

    // Strip negative sign from the integer part
    const positiveInteger = integerPart.replace('-', '')
    const formattedInteger = positiveInteger.replace(/\B(?=(\d{3})+(?!\d))/g, " ")

    if (!fractionPart) {
        return formattedInteger
    }

    const truncatedFraction = fractionPart.slice(0, 1)

    return `${formattedInteger},${truncatedFraction}`
}
